import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { SettingsInterface } from "../../utility/interface/settings";

const initialState: SettingsInterface = {
  lang: "en",
  menuKey: "1",
  conversionRate: null,
  lastUpdateUnix: null,
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    updateConversionRate: (state, action) => {
      state.conversionRate = action.payload.rate;
      state.lastUpdateUnix = action.payload.lastUpdateUnix;
    },
    updateLang: (state, action: PayloadAction<any>) => {
      return { ...state, lang: action.payload };
    },
    updateMenuKey: (state, action: PayloadAction<any>) => {
      return { ...state, menuKey: action.payload };
    },
    removeSettingsInfo: (state) => {
      return initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  updateConversionRate,
  updateLang,
  updateMenuKey,
  removeSettingsInfo,
} = settingsSlice.actions;

export default settingsSlice.reducer;
